import Model from './BaseModel'
import Reseller from './Reseller'
import i18n from '@/plugins/i18n'
import axios from '@/plugins/axios'

export default class Address extends Model {
    resourceName() {
        return 'addresses'
    }

    fields() {
        return [
            'reseller_id',
            'zip_code',
            'street',
            'number',
            'district',
            'complement',
            'city_name',
            'state_name',
            'city_id',
            'state_id',
            'active',
            'created_at',
            'deleted_at',
            'fiscal_address',
        ]
    }

    relationships() {
        return {
            resellers: new Reseller(),
        }
    }

    computed() {
        return {
            readableAddress(address) {
                return `${address.street}, ${address.number}, ${
                    address.complement ? address.complement + ' - ' : ''
                }${address.district}`
            },
            readableCity(address) {
                return `${address.city_name} - ${address.state_name}`
            },
            addressShort(address) {
                return `${address.street}, ${address.number}`
            },
            activeText(address) {
                return address.active
                    ? i18n.t('resources.address.getters.active.true')
                    : i18n.t('resources.address.getters.active.false')
            },
            fiscalAddressText(address) {
                return address.fiscal_address
                    ? i18n.t('resources.address.getters.fiscalAddress.true')
                    : i18n.t('resources.address.getters.fiscalAddress.false')
            },
        }
    }

    get tableColumns() {
        return [
            {
                text: i18n.t('resources.address.attributes.addressShort'),
                value: 'addressShort',
            },
            {
                text: i18n.t('resources.address.attributes.readableCity'),
                value: 'readableCity',
            },
            {
                text: i18n.t('resources.address.attributes.active'),
                value: 'activeText',
            },
            {
                text: i18n.t('resources.address.attributes.fiscalAddress'),
                value: 'fiscalAddressText',
            },
            {
                text: i18n.t('tables.actions'),
                value: 'action',
                sortable: false,
                align: 'end',
            },
        ]
    }

    async findZipCode() {
        let res = await axios.get(
            `${this.resourceName()}/zip-code/${this.zip_code.replace('-', '')}`,
        )

        if (!res) return null

        return res.data
    }
}
